export const postWorkCenterInitialState = {
	workCenters: null,
	error: null,
	errorShow: false,
	loading: false,
};
